import { render, staticRenderFns } from "./StoryTeasersSlider.vue?vue&type=template&id=6227d417&scoped=true"
import script from "./StoryTeasersSlider.vue?vue&type=script&lang=js"
export * from "./StoryTeasersSlider.vue?vue&type=script&lang=js"
import style0 from "./StoryTeasersSlider.vue?vue&type=style&index=0&id=6227d417&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6227d417",
  null
  
)

export default component.exports